
import 'jquery';
import 'lity';
import jcf from '../../UM-Base/lib/jcf';
import Flickity from 'flickity';

export default {
  init(components) {
    Flickity.defaults.dragThreshold = 20

    // Disable transition during a resize
    $(window).on('resize', window.requestAnimationFrame.bind(window, () => {
      $('body').addClass('no-transition');

      setTimeout(window.requestAnimationFrame.bind(window, () => {
        $('body').removeClass('no-transition');
      }, 50));
    }));

    // Initiate JCF with limited scope
    jcf.replaceAll('.search-filters__top, .search-filters__bottom');
    jcf.destroy('input[type="radio"], input[type="checkbox"]');

    $('a, button, [type="button"]').on('click', (e) => {
      // If this is a mouse click (rather than an enter click), don't apply focus styling
      if (typeof e.originalEvent !== 'undefined' && e.originalEvent.detail > 0) {
        $(e.currentTarget).blur();
      }
    });

    // REW multi-language home logo links
    function updateHeaderBrandHref() {
      const brandLink = document.querySelector('.header__brand') || document.querySelector('.nav-builder__logo a');
      if (!brandLink) return;

      const match = window.location.pathname.match(/^\/([a-zA-Z]{2})(\/|$)/);
      if (!match) return;

      brandLink.setAttribute('href', `/${match[1]}`);
      console.log('Updated header brand link with language code.', match[1]);
    }
    updateHeaderBrandHref();

  },

  finalize() {
    $('body').addClass('stage-1-loaded stage-2-loaded');
  }
};
